export async function createPayFastCheckout({
  amount,
  itemName,
  itemDescription = '',
  successPath,
  cancelPath,
  metadata = {},
  customer = {}
}) {
  const response = await fetch('/api/payfast/checkout', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      amount: Number(amount),
      itemName,
      itemDescription,
      successUrl: `${window.location.origin}${successPath}`,
      cancelUrl: `${window.location.origin}${cancelPath}`,
      metadata,
      customer
    })
  });

  const data = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw new Error(data.error || 'Could not start PayFast checkout');
  }

  if (!data.actionUrl || !data.fields) {
    throw new Error('PayFast checkout details missing');
  }

  return data;
}

export function redirectToPayFast(checkout) {
  const form = document.createElement('form');
  form.method = 'POST';
  form.action = checkout.actionUrl;
  form.enctype = 'application/x-www-form-urlencoded';
  form.acceptCharset = 'UTF-8';
  form.style.display = 'none';

  Object.entries(checkout.fields).forEach(([name, value]) => {
    const input = document.createElement('input');
    input.type = 'hidden';
    input.name = name;
    input.value = String(value);
    form.appendChild(input);
  });

  document.body.appendChild(form);
  form.submit();
}

export async function getPayFastPaymentStatus(orderId) {
  const response = await fetch(`/api/payfast/status?orderId=${encodeURIComponent(orderId)}`);
  const data = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw new Error(data.error || 'Unable to fetch payment status');
  }
  return data;
}

export async function waitForPayFastPayment(orderId, {
  intervalMs = 3000,
  timeoutMs = 60000
} = {}) {
  const startedAt = Date.now();

  while (Date.now() - startedAt < timeoutMs) {
    const status = await getPayFastPaymentStatus(orderId);
    if (String(status.paymentStatus || '').toLowerCase() === 'paid') {
      return status;
    }
    await new Promise((resolve) => setTimeout(resolve, intervalMs));
  }

  throw new Error('Payment confirmation is still pending. Please refresh in a moment.');
}
